import React, { useState, useCallback, useContext, useEffect } from "react";
import { toast } from "react-toastify";
import { add, format, parseISO } from "date-fns";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
// import { SocketContext } from "../../context/Socket/SocketContext";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import {
  Button,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Table,
  TableHead,
  TableContainer,
  Paper,
  Tooltip,
  Typography,
  CircularProgress,
  Box,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem as MuiMenuItem,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import {
  Edit,
  CheckCircle,
  SignalCellularConnectedNoInternet2Bar,
  SignalCellularConnectedNoInternet0Bar,
  SignalCellular4Bar,
  CropFree,
  DeleteOutline,
  Facebook,
  Instagram,
  WhatsApp,
  Sync,
  Telegram,
  SyncAlt,
  Refresh,
  HeadsetMic,
  AddCircleOutline,
} from "@material-ui/icons";
import WebhookIcon from '@mui/icons-material/Webhook';
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";
import TableRowSkeleton from "../../components/TableRowSkeleton";

import api from "../../services/api";
import WhatsAppModal from "../../components/WhatsAppModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import QrcodeModal from "../../components/QrcodeModal";
import { i18n } from "../../translate/i18n";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import toastError from "../../errors/toastError";
import formatSerializedId from '../../utils/formatSerializedId';
import { AuthContext } from "../../context/Auth/AuthContext";
import usePlans from "../../hooks/usePlans";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ForbiddenPage from "../../components/ForbiddenPage";
import { Can } from "../../components/Can";

const useStyles = makeStyles((theme) => ({
  tableHeader: {
    fontWeight: 'bold',
    backgroundColor: "#1e1e1e",
    color: "#fff",
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
  
    position: "sticky",
    top: 0,},
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    borderRadius: 16,
    backgroundColor: theme.palette.type === 'dark' ? '#2A2D32 !important' : theme.palette.background.paper,
  },
  scrollArea: {
    flex: 1,
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  customTableCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: theme.typography.pxToRem(14),
    border: "1px solid #dadde9",
    maxWidth: 450,
  },
  tooltipPopper: {
    textAlign: "center",
  },
  buttonProgress: {
    color: green[500],
  },
  actionButton: {
    padding: "6px 12px !important",
    height: "32px !important",
    fontSize: "0.8rem !important",
    textTransform: "none",
    whiteSpace: "nowrap",
    minWidth: "auto !important",
    lineHeight: "1.2 !important",
    [theme.breakpoints.down("md")]: {
      padding: "4px 8px !important",
      height: "28px !important",
      fontSize: "0.75rem !important",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "2px 4px !important",
      height: "24px !important",
      fontSize: "0.65rem !important",
      margin: "2px !important",
    }
  },
  btnTransfer: {
    backgroundColor: '#00B0FF',
    color: 'white',
    margin: '0 4px',
    padding: '8px',
    boxShadow: '0 2px 6px rgba(0,176,255,0.4)',
    transition: 'all 0.3s ease',
    '&:hover': { backgroundColor: '#0081CB', transform: 'scale(1.08)' },
    '& svg': { fontSize: '1.2rem' },
    [theme.breakpoints.down("sm")]: {
      padding: '6px',
      margin: '0 2px',
      '& svg': { fontSize: '1rem' }
    }
  },
  btnRestart: {
    backgroundColor: '#FF9100',
    color: 'white',
    margin: '0 4px',
    padding: '8px',
    boxShadow: '0 2px 6px rgba(255,145,0,0.4)',
    transition: 'all 0.3s ease',
    '&:hover': { backgroundColor: '#C56000', transform: 'scale(1.08)' },
    '& svg': { fontSize: '1.2rem' },
    [theme.breakpoints.down("sm")]: {
      padding: '6px',
      margin: '0 2px',
      '& svg': { fontSize: '1rem' }
    }
  },
  btnSupport: {
    backgroundColor: '#00E676',
    color: 'white',
    margin: '0 4px',
    padding: '8px',
    boxShadow: '0 2px 6px rgba(0,230,118,0.4)',
    transition: 'all 0.3s ease',
    '&:hover': { backgroundColor: '#00B248', transform: 'scale(1.08)' },
    '& svg': { fontSize: '1.2rem' },
    [theme.breakpoints.down("sm")]: {
      padding: '6px',
      margin: '0 2px',
      '& svg': { fontSize: '1rem' }
    }
  },
  btnNewConnection: {
    backgroundColor: '#AA00FF',
    color: 'white',
    margin: '0 4px',
    padding: '8px',
    boxShadow: '0 2px 6px rgba(170,0,255,0.4)',
    transition: 'all 0.3s ease',
    '&:hover': { backgroundColor: '#7200CA', transform: 'scale(1.08)' },
    '& svg': { fontSize: '1.2rem' },
    [theme.breakpoints.down("sm")]: {
      padding: '6px',
      margin: '0 2px',
      '& svg': { fontSize: '1rem' }
    }
  },
}));

function CircularProgressWithLabel(props) {
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress variant="determinate" {...props} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="caption"
          component="div"
          color="textSecondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

const CustomToolTip = ({ title, content, children }) => {
  const classes = useStyles();

  return (
    <Tooltip
      arrow
      classes={{
        tooltip: classes.tooltip,
        popper: classes.tooltipPopper,
      }}
      title={
        <React.Fragment>
          <Typography gutterBottom color="inherit">
            {title}
          </Typography>
          {content && <Typography>{content}</Typography>}
        </React.Fragment>
      }
    >
      {children}
    </Tooltip>
  );
};

const IconChannel = (channel, isDarkMode) => {
  switch (channel) {
    case "facebook":
      return <CustomToolTip title="Facebook"><Facebook style={{ color: isDarkMode ? "#4facfe" : "#3b5998" }} /></CustomToolTip>;
    case "instagram":
      return <CustomToolTip title="Instagram"><Instagram style={{ color: "#e1306c" }} /></CustomToolTip>;
    case "whatsapp":
      return <CustomToolTip title="WhatsApp Baileys"><WhatsApp style={{ color: isDarkMode ? "#ffffff" : "#000000" }} /></CustomToolTip>;
    case "whatsapp_oficial":
      return <CustomToolTip title="WhatsApp API Oficial"><WhatsApp style={{ color: "#25d366" }} /></CustomToolTip>;
    case "telegram":
      return <CustomToolTip title="Telegram"><Telegram style={{ color: "#0088cc" }} /></CustomToolTip>;
    default:
      return "error";
  }
};

const Connections = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isDarkMode = theme.mode === 'dark' || theme.palette.type === 'dark' || theme.palette.mode === 'dark';

  const { whatsApps, loading, reload } = useContext(WhatsAppsContext);
  const [whatsAppModalOpen, setWhatsAppModalOpen] = useState(false);
  const [brands, setBrands] = useState([]);
  const [statusImport, setStatusImport] = useState([]);
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [selectedWhatsApp, setSelectedWhatsApp] = useState(null);
  const [channel, setChannel] = useState("whatsapp");
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const history = useHistory();
  const confirmationModalInitialState = {
    action: "",
    title: "",
    message: "",
    whatsAppId: "",
    open: false,
  };
  const [confirmModalInfo, setConfirmModalInfo] = useState(confirmationModalInitialState);
  const [planConfig, setPlanConfig] = useState(false);
  const [transferModalOpen, setTransferModalOpen] = useState(false);
  const [sourceConnection, setSourceConnection] = useState("");
  const [targetConnection, setTargetConnection] = useState("");
  const [preDeleteModalOpen, setPreDeleteModalOpen] = useState(false);
  const [whatsAppToDelete, setWhatsAppToDelete] = useState(null);
  const [collapsedBrands, setCollapsedBrands] = useState({});
  const toggleBrand = (id) => setCollapsedBrands(prev => ({...prev, [id]: prev[id] === false ? true : false}));
  const [transferProgressModalOpen, setTransferProgressModalOpen] = useState(false);
  const [transferProgress, setTransferProgress] = useState({ current: 0, total: 0, percentage: 0 });

  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);

  const companyId = user.companyId;

  const { getPlanCompany } = usePlans();

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const { data } = await api.get("/brands");
        setBrands(data.brands || data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchBrands();
  }, []);


  useEffect(() => {
    async function fetchData() {
      const planConfigs = await getPlanCompany(undefined, companyId);
      setPlanConfig(planConfigs)
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const responseFacebook = (response) => {
    if (response.status !== "unknown") {
      const { accessToken, id } = response;

      api
        .post("/facebook", {
          facebookUserId: id,
          facebookUserToken: accessToken,
        })
        .then((response) => {
          toast.success(i18n.t("connections.facebook.success"));
          if (response.data?.whatsapps && response.data.whatsapps.length > 0) {
            handleEditWhatsApp(response.data.whatsapps[0]);
          }
        })
        .catch((error) => {
          toastError(error);
        });
    }
  };

  const responseInstagram = (response) => {
    if (response.status !== "unknown") {
      const { accessToken, id } = response;

      api
        .post("/facebook", {
          addInstagram: true,
          facebookUserId: id,
          facebookUserToken: accessToken,
        })
        .then((response) => {
          toast.success(i18n.t("connections.facebook.success"));
          if (response.data?.whatsapps && response.data.whatsapps.length > 0) {
            handleEditWhatsApp(response.data.whatsapps[0]);
          }
        })
        .catch((error) => {
          toastError(error);
        });
    }
  };

  useEffect(() => {
    // const socket = socketManager.GetSocket();

    socket.on(`importMessages-${user.companyId}`, (data) => {
      if (data.action === "refresh") {
        setStatusImport([]);
        history.go(0);
      }
      if (data.action === "update") {
        setStatusImport(data.status);
      }
    });

    socket.on(`transferTickets-${user.companyId}`, (data) => {
      if (data.action === "progress") {
        setTransferProgress({
          current: data.current,
          total: data.total,
          percentage: Math.round((data.current / data.total) * 100)
        });
      }
      if (data.action === "completed") {
        setTransferProgressModalOpen(false);
        setTransferProgress({ current: 0, total: 0, percentage: 0 });
        toast.success(i18n.t("transferTicketConnectionModal.successMessage", { transferred: data.transferred }));
        handleCloseTransferModal();
      }
      if (data.action === "error") {
        setTransferProgressModalOpen(false);
        setTransferProgress({ current: 0, total: 0, percentage: 0 });
        toast.error(i18n.t("transferTicketConnectionModal.errorMessage"));
      }
    });

    /* return () => {
      socket.disconnect();
    }; */
  }, [whatsApps]);

  const handleStartWhatsAppSession = async (whatsAppId) => {
    try {
      await api.post(`/whatsappsession/${whatsAppId}`);
    } catch (err) {
      toastError(err);
    }
  };

  const handleRequestNewQrCode = async (whatsAppId) => {
    try {
      await api.put(`/whatsappsession/${whatsAppId}`);
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenWhatsAppModal = (channel) => {
    setChannel(channel)
    setSelectedWhatsApp(null);
    setWhatsAppModalOpen(true);
  };

  const handleCloseWhatsAppModal = useCallback(() => {
    setWhatsAppModalOpen(false);
    setSelectedWhatsApp(null);
    reload(); // [ANTIGRAVITY] FIX: Force reload list after save/edit
  }, [setSelectedWhatsApp, setWhatsAppModalOpen, reload]);

  const handleOpenQrModal = (whatsApp) => {
    setSelectedWhatsApp(whatsApp);
    setQrModalOpen(true);
  };

  const handleCloseQrModal = useCallback(() => {
    setSelectedWhatsApp(null);
    setQrModalOpen(false);
  }, [setQrModalOpen, setSelectedWhatsApp]);

  const handleEditWhatsApp = (whatsApp) => {
    setChannel(whatsApp.channel)
    setSelectedWhatsApp(whatsApp);
    setWhatsAppModalOpen(true);
  };

  const handleSyncTemplates = async (whatsAppId) => {
    await api.get(`/whatsapp/sync-templates/${whatsAppId}`);
  }

  const handleCopyWebhook = (url) => {
    navigator.clipboard.writeText(url); // Copia o token para a área de transferência    
  };

  const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleOpenConfirmationModal = (action, whatsAppId) => {
    if (action === "disconnect") {
      setConfirmModalInfo({
        action: action,
        title: i18n.t("connections.confirmationModal.disconnectTitle"),
        message: i18n.t("connections.confirmationModal.disconnectMessage"),
        whatsAppId: whatsAppId,
      });
    }

    if (action === "delete") {
      setConfirmModalInfo({
        action: action,
        title: i18n.t("connections.confirmationModal.deleteTitle"),
        message: i18n.t("connections.confirmationModal.deleteMessage"),
        whatsAppId: whatsAppId,
      });
    }
    if (action === "closedImported") {
      setConfirmModalInfo({
        action: action,
        title: i18n.t("connections.confirmationModal.closedImportedTitle"),
        message: i18n.t("connections.confirmationModal.closedImportedMessage"),
        whatsAppId: whatsAppId,
      });
    }

    setConfirmModalOpen(true);
  };

  const handleSubmitConfirmationModal = async () => {
    if (confirmModalInfo.action === "disconnect") {
      try {
        await api.delete(`/whatsappsession/${confirmModalInfo.whatsAppId}`);
      } catch (err) {
        toastError(err);
      }
    }

    if (confirmModalInfo.action === "delete") {
      try {
        await api.delete(`/whatsapp/${confirmModalInfo.whatsAppId}`);
        toast.success(i18n.t("connections.toasts.deleted"));
      } catch (err) {
        toastError(err);
      }
    }
    if (confirmModalInfo.action === "closedImported") {
      try {
        await api.post(`/closedimported/${confirmModalInfo.whatsAppId}`);
        toast.success(i18n.t("connections.toasts.closedimported"));
      } catch (err) {
        toastError(err);
      }
    }


    setConfirmModalInfo(confirmationModalInitialState);
  };


  const renderImportButton = (whatsApp) => {
    if (whatsApp?.statusImportMessages === "renderButtonCloseTickets") {
      return (
        <Button
          style={{ marginLeft: 12 }}
          size="small"
          variant="outlined"
          color="primary"
          onClick={() => {
            handleOpenConfirmationModal("closedImported", whatsApp.id);
          }}
        >
          {i18n.t("connections.buttons.closedImported")}
        </Button>
      );
    }

    if (whatsApp?.importOldMessages) {
      let isTimeStamp = !isNaN(
        new Date(Math.floor(whatsApp?.statusImportMessages)).getTime()
      );

      if (isTimeStamp) {
        const ultimoStatus = new Date(
          Math.floor(whatsApp?.statusImportMessages)
        ).getTime();
        const dataLimite = +add(ultimoStatus, { seconds: +35 }).getTime();
        if (dataLimite > new Date().getTime()) {
          return (
            <>
              <Button
                disabled
                style={{ marginLeft: 12 }}
                size="small"
                endIcon={
                  <CircularProgress
                    size={12}
                    className={classes.buttonProgress}
                  />
                }
                variant="outlined"
                color="primary"
              >
                {i18n.t("connections.buttons.preparing")}
              </Button>
            </>
          );
        }
      }
    }
  };

  const renderActionButtons = (whatsApp) => {
    return (
      <>
        {whatsApp.channel === "whatsapp" && whatsApp.status === "qrcode" && (
          <Can
            role={user.profile === "user" && user.allowConnections === "enabled" ? "admin" : user.profile}
            perform="connections-page:addConnection"
            yes={() => (
              <Button
                size="small"
                variant="contained"
                color="primary"
                onClick={() => handleOpenQrModal(whatsApp)}
              >
                {i18n.t("connections.buttons.qrcode")}
              </Button>
            )}
          />
        )}
        {whatsApp.channel === "whatsapp" && whatsApp.status === "DISCONNECTED" && (
          <Can
            role={user.profile === "user" && user.allowConnections === "enabled" ? "admin" : user.profile}
            perform="connections-page:addConnection"
            yes={() => (
              <>
                <Button
                  size="small"
                  variant="outlined"
                  color="primary"
                  onClick={() => handleStartWhatsAppSession(whatsApp.id)}
                >
                  {i18n.t("connections.buttons.tryAgain")}
                </Button>{" "}
                <Button
                  size="small"
                  variant="outlined"
                  color="secondary"
                  onClick={() => handleRequestNewQrCode(whatsApp.id)}
                >
                  {i18n.t("connections.buttons.newQr")}
                </Button>
              </>
            )}
          />
        )}
        {(whatsApp.channel === "whatsapp" && (whatsApp.status === "CONNECTED" ||
          whatsApp.status === "PAIRING" ||
          whatsApp.status === "TIMEOUT")) && (
            <Can
              role={user.profile}
              perform="connections-page:addConnection"
              yes={() => (
                <>
                  <Button
                    size="small"
                    variant="outlined"
                    color="secondary"
                    onClick={() => {
                      handleOpenConfirmationModal("disconnect", whatsApp.id);
                    }}
                  >
                    {i18n.t("connections.buttons.disconnect")}
                  </Button>

                  {renderImportButton(whatsApp)}
                </>
              )}
            />
          )}
        {(whatsApp.channel === "whatsapp" && whatsApp.status === "OPENING") && (
          <>
            <Button size="small" variant="outlined" disabled color="default">
              {i18n.t("connections.buttons.connecting")}
            </Button>
            <Button
              size="small"
              variant="outlined"
              color="secondary"
              onClick={() => handleRequestNewQrCode(whatsApp.id)}
            >
              {i18n.t("connections.buttons.newQr")}
            </Button>
            <Button
              size="small"
              variant="outlined"
              color="secondary"
              onClick={() => {
                handleOpenConfirmationModal("disconnect", whatsApp.id);
              }}
              style={{ marginLeft: 8 }}
            >
              {i18n.t("connections.buttons.disconnect")}
            </Button>
          </>
        )}
        {whatsApp.channel === "whatsapp_oficial" && whatsApp.status === "DISCONNECTED" && (
          <Button
            size="small"
            variant="outlined"
            style={{ color: "#00b0ff", borderColor: "#00b0ff", textTransform: "none", fontWeight: 600 }}
            onClick={async () => {
              try {
                await api.put(`/whatsapp/${whatsApp.id}`, { status: "CONNECTED" });
                toast.success(i18n.t("connections.buttons.activate") || "Conexión activada correctamente.");
              } catch (err) {
                toastError(err);
              }
            }}
          >
            {i18n.t("connections.buttons.activate") || "Activar Conexión"}
          </Button>
        )}
      </>
    );
  };

  const renderStatusToolTips = (whatsApp) => {
    return (
      <div className={classes.customTableCell}>
        {/* [ANTIGRAVITY] API Oficial: Conexión Desactivada o Activada */}
        {whatsApp.channel === "whatsapp_oficial" && whatsApp.status === "DISCONNECTED" && (
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <SignalCellularConnectedNoInternet0Bar style={{ color: "#f50057" }} />
            <span style={{ color: "#f50057", fontWeight: 600, fontSize: 12, whiteSpace: "nowrap" }}>
              Conexión Desactivada
            </span>
          </div>
        )}
        {whatsApp.channel === "whatsapp_oficial" && whatsApp.status === "CONNECTED" && (
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <SignalCellular4Bar style={{ color: green[500] }} />
            <span style={{ color: green[600], fontWeight: 600, fontSize: 12, whiteSpace: "nowrap" }}>
              Conexión Activada
            </span>
          </div>
        )}
        {/* Conexiones no Oficial (Baileys, Facebook, Instagram) */}
        {whatsApp.channel !== "whatsapp_oficial" && whatsApp.status === "DISCONNECTED" && (
          <CustomToolTip
            title={i18n.t("connections.toolTips.disconnected.title")}
            content={i18n.t("connections.toolTips.disconnected.content")}
          >
            <SignalCellularConnectedNoInternet0Bar color="secondary" />
          </CustomToolTip>
        )}
        {whatsApp.status === "OPENING" && (
          <CircularProgress size={24} className={classes.buttonProgress} />
        )}
        {whatsApp.status === "qrcode" && (
          <CustomToolTip
            title={i18n.t("connections.toolTips.qrcode.title")}
            content={i18n.t("connections.toolTips.qrcode.content")}
          >
            <CropFree />
          </CustomToolTip>
        )}
        {whatsApp.channel !== "whatsapp_oficial" && whatsApp.status === "CONNECTED" && (
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <CustomToolTip title={i18n.t("connections.toolTips.connected.title")}>
              <SignalCellular4Bar style={{ color: green[500] }} />
            </CustomToolTip>
            {whatsApp.warmupInfo?.inWarmup && (
              <CustomToolTip
                title="Pausa Anti-Ban Activa"
                content={`Sincronización inicial con WhatsApp en progreso. Las campañas salientes esperan ${whatsApp.warmupInfo.remainingSeconds}s para proteger la línea contra baneos.`}
              >
                <span style={{ fontSize: 11, background: "rgba(255, 152, 0, 0.15)", color: "#ff9800", padding: "2px 6px", borderRadius: 10, fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 2 }}>
                  🛡️ Warmup {whatsApp.warmupInfo.remainingSeconds}s
                </span>
              </CustomToolTip>
            )}
          </div>
        )}
        {(whatsApp.status === "TIMEOUT" || whatsApp.status === "PAIRING") && (
          <CustomToolTip
            title={i18n.t("connections.toolTips.timeout.title")}
            content={i18n.t("connections.toolTips.timeout.content")}
          >
            <SignalCellularConnectedNoInternet2Bar color="secondary" />
          </CustomToolTip>
        )}
      </div>
    );
  };

  const restartWhatsapps = async () => {

    try {
      await api.post(`/whatsapp-restart/`);
      toast.success(i18n.t("connections.waitConnection"));
    } catch (err) {
      toastError(err);
    }
  }

  const handleOpenTransferModal = () => {
    setTransferModalOpen(true);
  };

  const handleCloseTransferModal = () => {
    setTransferModalOpen(false);
    setSourceConnection("");
    setTargetConnection("");
  };

  const handleCloseTransferProgressModal = () => {
    setTransferProgressModalOpen(false);
    setTransferProgress({ current: 0, total: 0, percentage: 0 });
  };

  const handleTransferTickets = async () => {
    if (!sourceConnection || !targetConnection) {
      toast.error(i18n.t("transferTicketConnectionModal.errorSelectConnections"));
      return;
    }

    if (sourceConnection === targetConnection) {
      toast.error(i18n.t("transferTicketConnectionModal.errorSameConnections"));
      return;
    }

    try {
      const response = await api.post(`/transfer-tickets`, {
        sourceConnectionId: sourceConnection,
        targetConnectionId: targetConnection
      });

      if (response.data.requiresProgress) {
        setTransferModalOpen(false);
        setTransferProgressModalOpen(true);
        setTransferProgress({ current: 0, total: response.data.totalTickets, percentage: 0 });
      } else {
        toast.success(i18n.t("transferTicketConnectionModal.successMessage", { transferred: response.data.transferred || 0 }));
        handleCloseTransferModal();
      }
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenPreDeleteModal = (whatsAppId) => {
    setWhatsAppToDelete(whatsAppId);
    setPreDeleteModalOpen(true);
  };

  const handleClosePreDeleteModal = () => {
    setPreDeleteModalOpen(false);
    setWhatsAppToDelete(null);
  };

  const handleConfirmTransferDone = () => {
    setPreDeleteModalOpen(false);
    handleOpenConfirmationModal("delete", whatsAppToDelete);
    setWhatsAppToDelete(null);
  };


  const renderConnectionRow = (whatsApp) => {
    return (
      
                        <TableRow key={whatsApp.id}>
                          <TableCell align="center">
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
                              {IconChannel(whatsApp.channel, isDarkMode)}
                              <span style={{ fontSize: 10, color: "#999", fontWeight: 600, lineHeight: 1 }}>
                                #{whatsApp.id}
                              </span>
                            </div>
                          </TableCell>
                          <TableCell align="center">
                            <div className={classes.customTableCell}>
                              <span
                                style={{
                                  backgroundColor: whatsApp.color,
                                  width: 60,
                                  height: 20,
                                  alignSelf: "center",
                                }}
                              />
                            </div>
                          </TableCell>
                          <TableCell align="center">{whatsApp.name}</TableCell>
                          <TableCell align="center">
                            {whatsApp.channel === 'whatsapp' && whatsApp.number
                              ? <>{formatSerializedId(whatsApp.number)}</>
                              : whatsApp.channel === 'whatsapp_oficial' && whatsApp.phone_number
                                ? <>{formatSerializedId(whatsApp.phone_number)}</>
                                : "-"}
                          </TableCell>
                          <TableCell align="center">{renderStatusToolTips(whatsApp)}</TableCell>
                          <TableCell align="center">{renderActionButtons(whatsApp)}</TableCell>
                          <TableCell align="center">{format(parseISO(whatsApp.updatedAt), "dd/MM/yy HH:mm")}</TableCell>
                          <TableCell align="center">
                            {whatsApp.isDefault && (
                              <div className={classes.customTableCell}>
                                <CheckCircle style={{ color: green[500] }} />
                              </div>
                            )}
                          </TableCell>
                          <Can
                            role={user.profile}
                            perform="connections-page:addConnection"
                            yes={() => (
                              <TableCell align="center">
                                <div style={{ display: 'flex', flexWrap: 'nowrap', justifyContent: 'center', gap: '2px' }}>
                                  <IconButton
                                    size="small"
                                    style={{ padding: 4 }}
                                    onClick={() => handleEditWhatsApp(whatsApp)}
                                  >
                                    <Edit fontSize="small"  style={{ color: "#00a8ff" }} />
                                  </IconButton>

                                  <IconButton
                                    size="small"
                                    style={{ padding: 4 }}
                                    onClick={(e) => {
                                      handleOpenPreDeleteModal(whatsApp.id);
                                    }}
                                  >
                                    <DeleteOutline fontSize="small"  style={{ color: "#e84118" }} />
                                  </IconButton>
                                  {whatsApp.channel === 'whatsapp_oficial' && (
                                    <>
                                      <Tooltip title={i18n.t("connections.toolTips.syncTemplates")}>
                                        <IconButton
                                          size="small"
                                          style={{ padding: 4 }}
                                          aria-label="sync-templates"
                                          onClick={(e) => {
                                            handleSyncTemplates(whatsApp.id);
                                          }}
                                        >
                                          <Sync fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                      <Tooltip title={i18n.t("connections.toolTips.copyWebhook")}>
                                        <IconButton
                                          size="small"
                                          style={{ padding: 4 }}
                                          aria-label="copy-webhook"
                                          onClick={(e) => {
                                            handleCopyWebhook(whatsApp.waba_webhook);
                                          }}
                                        >
                                          <WebhookIcon fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                    </>
                                  )}
                                </div>
                              </TableCell>
                            )}
                          />
                        </TableRow>
    );
  };

  const totalConnections = Array.isArray(whatsApps) ? whatsApps.length : 0;
  const maxTotalConnections = planConfig?.plan?.connections || 1;
  const isGlobalLimitReached = totalConnections >= maxTotalConnections;

  const usedQr = Array.isArray(whatsApps) ? whatsApps.filter(w => !w.channel || w.channel === "whatsapp").length : 0;
  const maxConnQr = planConfig?.plan?.maxConnQr !== undefined && planConfig?.plan?.maxConnQr !== null ? Number(planConfig.plan.maxConnQr) : (planConfig?.plan?.useWhatsapp ? 1 : 0);
  const isQrDisabled = isGlobalLimitReached || !planConfig?.plan?.useWhatsapp || maxConnQr <= 0 || usedQr >= maxConnQr;

  const usedApi = Array.isArray(whatsApps) ? whatsApps.filter(w => w.channel === "whatsapp_oficial").length : 0;
  const maxConnApi = planConfig?.plan?.maxConnApi !== undefined && planConfig?.plan?.maxConnApi !== null ? Number(planConfig.plan.maxConnApi) : (planConfig?.plan?.useWhatsappOfficial ? 1 : 0);
  const isApiDisabled = isGlobalLimitReached || !planConfig?.plan?.useWhatsappOfficial || maxConnApi <= 0 || usedApi >= maxConnApi;

  const usedTg = Array.isArray(whatsApps) ? whatsApps.filter(w => w.channel === "telegram").length : 0;
  const maxConnTg = planConfig?.plan?.maxConnTelegram !== undefined && planConfig?.plan?.maxConnTelegram !== null ? Number(planConfig.plan.maxConnTelegram) : 0;
  const isTgDisabled = isGlobalLimitReached || maxConnTg <= 0 || usedTg >= maxConnTg;

  const usedFb = Array.isArray(whatsApps) ? whatsApps.filter(w => w.channel === "facebook").length : 0;
  const maxConnFb = planConfig?.plan?.maxConnMessenger !== undefined && planConfig?.plan?.maxConnMessenger !== null ? Number(planConfig.plan.maxConnMessenger) : (planConfig?.plan?.useFacebook ? 1 : 0);
  const isFbDisabled = isGlobalLimitReached || !planConfig?.plan?.useFacebook || maxConnFb <= 0 || usedFb >= maxConnFb;

  const usedIg = Array.isArray(whatsApps) ? whatsApps.filter(w => w.channel === "instagram").length : 0;
  const maxConnIg = planConfig?.plan?.maxConnIg !== undefined && planConfig?.plan?.maxConnIg !== null ? Number(planConfig.plan.maxConnIg) : (planConfig?.plan?.useInstagram ? 1 : 0);
  const isIgDisabled = isGlobalLimitReached || !planConfig?.plan?.useInstagram || maxConnIg <= 0 || usedIg >= maxConnIg;

  return (
    <MainContainer>
      <ConfirmationModal
        title={confirmModalInfo.title}
        open={confirmModalOpen}
        onClose={setConfirmModalOpen}
        onConfirm={handleSubmitConfirmationModal}
      >
        {confirmModalInfo.message}
      </ConfirmationModal>
      {qrModalOpen && (
        <QrcodeModal
          open={qrModalOpen}
          onClose={handleCloseQrModal}
          whatsAppId={!whatsAppModalOpen && selectedWhatsApp?.id}
        />
      )}
      <WhatsAppModal
        open={whatsAppModalOpen}
        onClose={handleCloseWhatsAppModal}
        whatsAppId={!qrModalOpen && selectedWhatsApp?.id}
        channel={channel}
      />
      <Dialog
        open={transferModalOpen}
        onClose={handleCloseTransferModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>{i18n.t("transferTicketConnectionModal.title")}</DialogTitle>
        <DialogContent>
          <Typography variant="body1" style={{ marginBottom: 24, lineHeight: 1.6 }}>
            {i18n.t("transferTicketConnectionModal.description")}
          </Typography>

          <div style={{ display: 'flex', alignItems: 'center', gap: 24, marginBottom: 24 }}>
            <FormControl fullWidth>
              <InputLabel>{i18n.t("transferTicketConnectionModal.fieldSource")}</InputLabel>
              <Select
                value={sourceConnection}
                onChange={(e) => setSourceConnection(e.target.value)}
                label={i18n.t("transferTicketConnectionModal.fieldSource")}
              >
                {whatsApps.map((whatsApp) => (
                  <MuiMenuItem key={whatsApp.id} value={whatsApp.id}>
                    {whatsApp.name}
                  </MuiMenuItem>
                ))}
              </Select>
            </FormControl>

            <div style={{ fontSize: 24, color: '#4caf50', fontWeight: 'bold' }}>
              →
            </div>

            <FormControl fullWidth>
              <InputLabel>{i18n.t("transferTicketConnectionModal.fieldTarget")}</InputLabel>
              <Select
                value={targetConnection}
                onChange={(e) => setTargetConnection(e.target.value)}
                label={i18n.t("transferTicketConnectionModal.fieldTarget")}
              >
                {whatsApps.map((whatsApp) => (
                  <MuiMenuItem key={whatsApp.id} value={whatsApp.id}>
                    {whatsApp.name}
                  </MuiMenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTransferModal} color="default">
            {i18n.t("transferTicketConnectionModal.buttons.cancel")}
          </Button>
          <Button onClick={handleTransferTickets} color="primary" variant="contained">
            {i18n.t("transferTicketConnectionModal.buttons.transfer")}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={transferProgressModalOpen}
        maxWidth="sm"
        fullWidth
        onClose={(e, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            handleCloseTransferProgressModal();
          }
        }}
      >
        <DialogTitle>{i18n.t("transferTicketConnectionModal.progressTitle")}</DialogTitle>
        <DialogContent>
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <Typography variant="h6" style={{ marginBottom: 16 }}>
              {i18n.t("transferTicketConnectionModal.progressLabel")}
            </Typography>

            <Box position="relative" display="inline-flex" marginBottom={2}>
              <CircularProgress
                variant="determinate"
                value={transferProgress.percentage}
                size={80}
                thickness={4}
              />
              <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position="absolute"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Typography variant="caption" component="div" color="textSecondary" style={{ fontSize: '14px', fontWeight: 'bold' }}>
                  {transferProgress.percentage}%
                </Typography>
              </Box>
            </Box>

            <Typography variant="body1" style={{ marginTop: 16 }}>
              {i18n.t("transferTicketConnectionModal.progressStatus", { current: transferProgress.current, total: transferProgress.total })}
            </Typography>

            <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
              {i18n.t("transferTicketConnectionModal.progressWait")}
            </Typography>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        open={preDeleteModalOpen}
        onClose={handleClosePreDeleteModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>{i18n.t("transferTicketConnectionModal.preDeleteTitle")}</DialogTitle>
        <DialogContent>
          <Typography variant="body1" style={{ marginBottom: 16 }}>
            {i18n.t("transferTicketConnectionModal.preDeleteMessage")}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePreDeleteModal} color="default">
            {i18n.t("transferTicketConnectionModal.buttons.no")}
          </Button>
          <Button onClick={handleConfirmTransferDone} color="primary" variant="contained">
            {i18n.t("transferTicketConnectionModal.buttons.yes")}
          </Button>
        </DialogActions>
      </Dialog>
      {user.profile === "user" && user.allowConnections === "disabled" ?
        <ForbiddenPage />
        :
        <Paper className={classes.mainPaper} variant="outlined">
          <MainHeader>
            <Title>{i18n.t("connections.title")} ({whatsApps.length})</Title>
            <MainHeaderButtonsWrapper>
              <Tooltip title={i18n.t("connections.buttons.transferTickets")} arrow>
                <IconButton
                  className={classes.btnTransfer}
                  onClick={handleOpenTransferModal}
                >
                  <SyncAlt />
                </IconButton>
              </Tooltip>

              <Tooltip title={i18n.t("connections.restartConnections")} arrow>
                <IconButton
                  className={classes.btnRestart}
                  onClick={restartWhatsapps}
                >
                  <Refresh />
                </IconButton>
              </Tooltip>

              <Tooltip title={i18n.t("connections.callSupport")} arrow>
                <IconButton
                  className={classes.btnSupport}
                  onClick={() => openInNewTab(`https://wa.me/${process.env.REACT_APP_NUMBER_SUPPORT}`)}
                >
                  <HeadsetMic />
                </IconButton>
              </Tooltip>
              <PopupState variant="popover" popupId="demo-popup-menu">
                {(popupState) => (
                  <React.Fragment>
                    <Can
                      role={user.profile}
                      perform="connections-page:addConnection"
                      yes={() => (
                        <>
                          <Tooltip title={i18n.t("connections.newConnection")} arrow>
                            <IconButton
                              {...bindTrigger(popupState)}
                              className={classes.btnNewConnection}
                            >
                              <AddCircleOutline />
                            </IconButton>
                          </Tooltip>
                          <Menu {...bindMenu(popupState)}>
                            {/* WHATSAPP */}
                            <MenuItem
                              disabled={isQrDisabled}
                              onClick={() => {
                                handleOpenWhatsAppModal();
                                popupState.close();
                              }}
                            >
                              <WhatsApp
                                fontSize="small"
                                style={{
                                  marginRight: "10px",
                                  color: isDarkMode ? "#ffffff" : "#000000",
                                }}
                              />
                              WhatsApp Baileys
                            </MenuItem>
                            {/* WHATSAPP OFICIAL */}
                            <MenuItem
                              disabled={isApiDisabled}
                              onClick={() => {
                                handleOpenWhatsAppModal("whatsapp_oficial");
                                popupState.close();
                              }}
                            >
                              <WhatsApp
                                fontSize="small"
                                style={{
                                  marginRight: "10px",
                                  color: "#25D366",
                                }}
                              />
                              WhatsApp API Oficial
                            </MenuItem>
                            {/* TELEGRAM */}
                            <MenuItem
                              disabled={isTgDisabled}
                              onClick={() => {
                                handleOpenWhatsAppModal("telegram");
                                popupState.close();
                              }}
                            >
                              <Telegram
                                fontSize="small"
                                style={{
                                  marginRight: "10px",
                                  color: "#0088cc",
                                }}
                              />
                              {i18n.t("connections.buttons.addTelegram")}
                            </MenuItem>
                            {/* FACEBOOK */}
                            <FacebookLogin
                              appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                              autoLoad={false}
                              fields="name,email,picture"
                              version="18.0"
                              scope={process.env.REACT_APP_REQUIRE_BUSINESS_MANAGEMENT?.toUpperCase() === "TRUE" ?
                                "public_profile,pages_messaging,pages_show_list,pages_manage_metadata,pages_manage_posts,pages_manage_engagement,pages_read_engagement,pages_read_user_content,business_management"
                                : "public_profile,pages_messaging,pages_show_list,pages_manage_metadata,pages_manage_posts,pages_manage_engagement,pages_read_engagement,pages_read_user_content"}
                              callback={responseFacebook}
                              render={(renderProps) => (
                                <MenuItem
                                  disabled={isFbDisabled}
                                  onClick={renderProps.onClick}
                                >
                                  <Facebook
                                    fontSize="small"
                                    style={{
                                      marginRight: "10px",
                                      color: isDarkMode ? "#4facfe" : "#3b5998",
                                    }}
                                  />
                                  Facebook
                                </MenuItem>
                              )}
                            />
                            {/* INSTAGRAM */}
                            <FacebookLogin
                              appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                              autoLoad={false}
                              fields="name,email,picture"
                              version="18.0"
                              scope={process.env.REACT_APP_REQUIRE_BUSINESS_MANAGEMENT?.toUpperCase() === "TRUE" ?
                                "public_profile,instagram_basic,instagram_manage_messages,instagram_manage_comments,pages_messaging,pages_show_list,pages_manage_metadata,business_management"
                                : "public_profile,instagram_basic,instagram_manage_messages,instagram_manage_comments,pages_messaging,pages_show_list,pages_manage_metadata"}
                              callback={responseInstagram}
                              render={(renderProps) => (
                                <MenuItem
                                  disabled={isIgDisabled}
                                  onClick={renderProps.onClick}
                                >
                                  <Instagram
                                    fontSize="small"
                                    style={{
                                      marginRight: "10px",
                                      color: "#e1306c",
                                    }}
                                  />
                                  Instagram
                                </MenuItem>
                              )}
                            />
                          </Menu>
                        </>
                      )}
                    />
                  </React.Fragment>
                )}
              </PopupState>
            </MainHeaderButtonsWrapper>
          </MainHeader>

          {
            statusImport?.all ? (
              <>
                <div style={{ margin: "auto", marginBottom: 12 }}>
                  <Card className={classes.root}>
                    <CardContent className={classes.content}>
                      <Typography component="h5" variant="h5">

                        {statusImport?.this === -1 ? i18n.t("connections.buttons.preparing") : i18n.t("connections.buttons.importing")}

                      </Typography>
                      {statusImport?.this === -1 ?
                        <Typography component="h6" variant="h6" align="center">

                          <CircularProgress
                            size={24}
                          />

                        </Typography>
                        :
                        <>
                          <Typography component="h6" variant="h6" align="center">
                            {`${i18n.t(`connections.typography.processed`)} ${statusImport?.this} ${i18n.t(`connections.typography.in`)} ${statusImport?.all}  ${i18n.t(`connections.typography.date`)}: ${statusImport?.date} `}
                          </Typography>
                          <Typography align="center">
                            <CircularProgressWithLabel
                              style={{ margin: "auto" }}
                              value={(statusImport?.this / statusImport?.all) * 100}
                            />
                          </Typography>
                        </>
                      }
                    </CardContent>
                  </Card>
                </div>
              </>
            ) : null
          }

          <TableContainer className={classes.scrollArea}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="center" className={classes.tableHeader}>{i18n.t("connections.table.channel")}</TableCell>
                  <TableCell align="center" className={classes.tableHeader}>{i18n.t("connections.table.color")}</TableCell>
                  <TableCell align="center" className={classes.tableHeader}>{i18n.t("connections.table.name")}</TableCell>
                  <TableCell align="center" className={classes.tableHeader}>{i18n.t("connections.table.number")}</TableCell>
                  <TableCell align="center" className={classes.tableHeader}>{i18n.t("connections.table.status")}</TableCell>
                  <TableCell align="center" className={classes.tableHeader}>{i18n.t("connections.table.session")}</TableCell>
                  <TableCell align="center" className={classes.tableHeader}>{i18n.t("connections.table.lastUpdate")}</TableCell>
                  <TableCell align="center" className={classes.tableHeader}>{i18n.t("connections.table.default")}</TableCell>
                  <Can
                    role={user.profile === "user" && user.allowConnections === "enabled" ? "admin" : user.profile}
                    perform="connections-page:addConnection"
                    yes={() => (
                      <TableCell align="center" className={classes.tableHeader}>{i18n.t("connections.table.actions")}</TableCell>
                    )}
                  />
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRowSkeleton />
                ) : (
                  <>
                    
                    {brands.map(brand => {
                      const brandWhatsapps = whatsApps?.filter(w => w.brandId === brand.id) || [];
                      if (brandWhatsapps.length === 0) return null;
                      const isCollapsed = collapsedBrands[brand.id] !== false;
                      return (
                        <React.Fragment key={brand.id}>
                          <TableRow onClick={() => toggleBrand(brand.id)} style={{ cursor: 'pointer', transition: 'background 0.3s' }} hover>
                            <TableCell colSpan={9} style={{ backgroundColor: isDarkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)', color: isDarkMode ? '#8be9fd' : '#000', fontWeight: 'bold', fontSize: '1rem', borderBottom: '2px solid rgba(0,0,0,0.1)' }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span style={{ fontSize: '1.2rem' }}>{isCollapsed ? '📁' : '📂'}</span>
                                Marca: {brand.name}
                                <span style={{ marginLeft: 'auto', fontSize: '0.8rem', opacity: 0.7 }}>
                                  {brandWhatsapps.length} conexiones (Click para {isCollapsed ? 'expandir' : 'contraer'})
                                </span>
                              </div>
                            </TableCell>
                          </TableRow>
                          {!isCollapsed && brandWhatsapps.map((whatsApp) => renderConnectionRow(whatsApp))}
                        </React.Fragment>
                      );
                    })}
                    {/* Unassigned whatsapps */}
                    {(() => {
                      const unassigned = whatsApps?.filter(w => !w.brandId) || [];
                      if (unassigned.length === 0) return null;
                      return (
                        <React.Fragment>
                          <TableRow>
                            <TableCell colSpan={9} style={{ backgroundColor: isDarkMode ? 'rgba(255,0,0,0.1)' : 'rgba(255,0,0,0.05)', color: isDarkMode ? '#ff5555' : '#d32f2f', fontWeight: 'bold', fontSize: '1rem', borderBottom: '2px solid rgba(0,0,0,0.1)' }}>
                              ⚠️ Sin Marca (Requiere asignación)
                            </TableCell>
                          </TableRow>
                          {unassigned.map((whatsApp) => renderConnectionRow(whatsApp))}
                        </React.Fragment>
                      );
                    })()}

                  </>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      }
    </MainContainer >

  );
};

export default Connections;
